/* -------------------------------------------------------------------------- */
/*                       Password Show hide                                   */
/* -------------------------------------------------------------------------- */

const passwordShowHideInit = async () => {
  let showPassword = true;
  let showConfirmPassword = true;
  showPassword === !showPassword;
  showConfirmPassword === !showConfirmPassword;

  const showHideSpan = document.querySelectorAll(".show-hide-span");
  if (showHideSpan) {
    showHideSpan.forEach((element, i) => {
      element.addEventListener("click", () => {
        //password
        const eyeSlashIcon = document.querySelector('.eye-slash-icon');
        const mainEyeIcon = document.querySelector('.main-eye-icon');

        //confirmPassword slashedConfirmEyeIcon is the slashed eye icon and mainConfirmEyeIcon is the unslashed eye icon
        const slashedConfirmEyeIcon = document.querySelector('.show-confirm-password');
        const mainConfirmEyeIcon = document.querySelector('.hide-confirm-password');

        if (showPassword && i === 0) {
          if (document.getElementById('split-login-password')) {
            document.getElementById('split-login-password').type = 'text'
          } else {
            document.getElementById('split-password').type = 'text'
          }

          //remove slash svg 
          eyeSlashIcon.classList.add('d-none');
          //show eye svg
          mainEyeIcon.classList.remove('d-none');

          // showHideIcon.classList.remove('fa-eye-slash')
          // showHideIcon.classList.add('fa-eye')
          showPassword = false;
        } else if (!showPassword && i === 0) {
          if (document.getElementById('split-login-password')) {
            document.getElementById('split-login-password').type = 'password';
          } else {
            document.getElementById('split-password').type = 'password';
          }

          //remove eye svg
          mainEyeIcon.classList.add('d-none');
          //show slash svg
          eyeSlashIcon.classList.remove('d-none');
          // showHideIcon.classList.remove('fa-eye')
          // showHideIcon.classList.add('fa-eye-slash')
          showPassword = true;
        } else if (showConfirmPassword && i === 1) {
          document.getElementById('split-confirm-password').type = 'text';

          slashedConfirmEyeIcon.classList.add('d-none');

          mainConfirmEyeIcon.classList.remove('d-none');

          // showHideConfirmPassword.classList.remove('fa-eye-slash')
          // showHideConfirmPassword.classList.add('fa-eye')
          showConfirmPassword = false;
        } else if (!showConfirmPassword && i === 1) {
          document.getElementById('split-confirm-password').type = 'password';

          //hide eye icon
          mainConfirmEyeIcon.classList.add('d-none');
          // show slashed icon
          slashedConfirmEyeIcon.classList.remove('d-none');

          // showHideConfirmPassword.classList.remove('fa-eye')
          // showHideConfirmPassword.classList.add('fa-eye-slash')
          showConfirmPassword = true;
        }

      }, true)
    })
  }
};


export default passwordShowHideInit;
